export const checkNonEmptyFields = (form, fields) => {
    for (let field of fields)
        // Check if the field is not null, and not empty in the case of a String
        if (!form[field] || (typeof form[field] === 'string' && !form[field].trim().length))
            return false;

    return true;
};

export default {checkNonEmptyFields};